var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceUpdatesImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#e7e6e6;}.c{fill:#8c94c9;}.d{fill:#97d3f1;}.e{opacity:0.995;}.f{fill:#007da0;}.g{fill:#0fb4d1;}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-123.807 83.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.907 -430.986)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M82.109,135.4l-.249-.117v-.015h-1.6a7.6,7.6,0,0,0-.806-1.949l1.1-1.1.029-.029-.015-.015.1-.264a.675.675,0,0,0-.161-.747l-1.553-1.553a.7.7,0,0,0-.747-.161l-.264.1-.015-.015-.029.029-1.1,1.1a7.6,7.6,0,0,0-1.949-.806v-1.6h-.015l-.117-.249a.712.712,0,0,0-.645-.41H71.925a.712.712,0,0,0-.645.41l-.117.249h-.015v1.6a7.6,7.6,0,0,0-1.949.806l-1.1-1.1-.029-.029-.015.015-.264-.1a.675.675,0,0,0-.747.161l-1.539,1.568a.7.7,0,0,0-.161.747l.1.264-.015.015.029.029,1.1,1.1a7.6,7.6,0,0,0-.806,1.949h-1.6v.015l-.249.117a.712.712,0,0,0-.41.645v2.183a.712.712,0,0,0,.41.645l.249.117v.015h1.612a7.6,7.6,0,0,0,.806,1.949l-1.1,1.1-.029.029.015.015-.1.264a.675.675,0,0,0,.161.747l1.553,1.553a.7.7,0,0,0,.747.161l.264-.1.015.015.029-.029,1.1-1.1a7.6,7.6,0,0,0,1.949.806v1.6h.015l.117.249a.712.712,0,0,0,.645.41h2.183a.712.712,0,0,0,.645-.41l.117-.249h.015v-1.6a7.6,7.6,0,0,0,1.949-.806l1.1,1.1.029.029.015-.015.264.1a.675.675,0,0,0,.747-.161l1.553-1.553a.7.7,0,0,0,.161-.747l-.1-.264.015-.015-.029-.029-1.1-1.1a7.6,7.6,0,0,0,.806-1.949h1.6V139l.249-.117a.712.712,0,0,0,.41-.645v-2.183A.808.808,0,0,0,82.109,135.4Zm-9.1,4.967a3.238,3.238,0,1,1,3.238-3.238A3.239,3.239,0,0,1,73.009,140.362Z",
    transform: "translate(56.593 253.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M136.8,65.968l-.132-.132h0l-.029-.015-.952-.366a4.811,4.811,0,0,0-.029-1.377l.938-.41.029-.015h0l.117-.132a.47.47,0,0,0,.073-.5l-.571-1.3a.465.465,0,0,0-.41-.278h-.176l-.029.015-.938.41a5.134,5.134,0,0,0-1-.952l.366-.952.015-.029h0l-.015-.176a.48.48,0,0,0-.293-.41l-1.319-.513a.447.447,0,0,0-.484.1l-.132.132h0l-.015.029-.366.952a4.812,4.812,0,0,0-1.377.029l-.41-.952-.015-.029h0l-.132-.117a.47.47,0,0,0-.5-.073l-1.3.571a.465.465,0,0,0-.278.41v.176h0l.015.029.41.938a5.137,5.137,0,0,0-.952,1l-.952-.366-.029-.015h0l-.176.015a.48.48,0,0,0-.41.293l-.513,1.333a.447.447,0,0,0,.1.484l.132.132h0l.029.015.952.366a4.812,4.812,0,0,0,.029,1.377l-.938.41-.029.015h0l-.117.132a.47.47,0,0,0-.073.5l.571,1.3a.465.465,0,0,0,.41.278h.176l.029-.015.938-.41a5.137,5.137,0,0,0,1,.952l-.366.952-.015.029h0l.015.176a.48.48,0,0,0,.293.41l1.333.513a.447.447,0,0,0,.484-.1l.132-.132h0l.015-.029.366-.952a4.812,4.812,0,0,0,1.377-.029l.41.938.015.029h0l.132.117a.47.47,0,0,0,.5.073l1.3-.571a.465.465,0,0,0,.278-.41v-.176h0l-.015-.029-.41-.938a5.136,5.136,0,0,0,.952-1l.952.366.029.015h0l.176-.015a.48.48,0,0,0,.41-.293l.513-1.333A.448.448,0,0,0,136.8,65.968Zm-6.711.879a2.116,2.116,0,1,1,2.74-1.2A2.12,2.12,0,0,1,130.093,66.847Z",
    transform: "translate(4.272 312.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M193.688,192.391l-.147-.147v-.015l-.029-.015-1.1-.425a6.463,6.463,0,0,0-.029-1.6l1.084-.469.029-.015v-.015l.147-.161a.516.516,0,0,0,.088-.571l-.659-1.509a.545.545,0,0,0-.484-.322h-.205v-.015l-.029.015-1.084.469a5.428,5.428,0,0,0-1.143-1.1l.425-1.1.015-.029h-.015l-.015-.205a.547.547,0,0,0-.337-.469l-1.539-.6a.548.548,0,0,0-.571.117l-.147.146h-.015l-.015.029-.425,1.1a6.465,6.465,0,0,0-1.6.029l-.469-1.084-.015-.029h-.015l-.161-.147a.516.516,0,0,0-.571-.088l-1.509.659a.545.545,0,0,0-.322.484v.205h-.015l.015.029.469,1.084a5.429,5.429,0,0,0-1.1,1.143l-1.1-.425-.029-.015v.015l-.205.015a.547.547,0,0,0-.469.337l-.6,1.538a.548.548,0,0,0,.117.571l.147.147v.015l.029.015,1.1.425a6.461,6.461,0,0,0,.029,1.6l-1.084.469-.029.015v.015l-.147.161a.516.516,0,0,0-.088.571l.659,1.509a.545.545,0,0,0,.484.322h.205v.015l.029-.015,1.084-.469a5.43,5.43,0,0,0,1.143,1.1l-.425,1.1-.015.029h.015l.015.205a.547.547,0,0,0,.337.469l1.539.6a.548.548,0,0,0,.571-.117l.147-.146h.015l.015-.029.425-1.1a6.462,6.462,0,0,0,1.6-.029l.469,1.084.015.029h.015l.161.147a.516.516,0,0,0,.571.088l1.509-.659a.546.546,0,0,0,.322-.484v-.205h.015l-.015-.029-.469-1.084a5.429,5.429,0,0,0,1.1-1.143l1.1.425.029.015v-.015l.205-.015a.547.547,0,0,0,.469-.337l.6-1.538A.542.542,0,0,0,193.688,192.391Zm-7.78,1a2.445,2.445,0,1,1,3.165-1.392A2.439,2.439,0,0,1,185.907,193.387Z",
    transform: "translate(-42.635 205.571)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceUpdatesImage);
export default __webpack_public_path__ + "static/media/deviceUpdatesImage.0dcfcf3a25a371a551f719e0d3b12fc0.svg";
export { ForwardRef as ReactComponent };